<template>
  <div class="admin-wrapper">
    <div class="admin-wrapper__header">
      <div class="admin-wrapper__content">
        <slot name="header"></slot>
      </div>
    </div>
    <div class="admin-wrapper__body">
      <div class="admin-wrapper__content">
        <slot></slot>
      </div>
    </div>
    <div class="admin-wrapper__loading" v-if="loading">
      <icon-spinner/>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, PropType, ref, watch,
} from 'vue'
import IconSpinner from '@/vue/icons/IconSpinner.vue'
import { useStore } from 'vuex'
import { key } from '@/vue/store'

export default defineComponent({
  name: 'AdminWrapper',
  props: {
    noStore: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  components: { IconSpinner },
  setup(props) {
    const loading = ref(false)
    if (!props.noStore) {
      const store = useStore(key)
      loading.value = store.state.routeLoading
      watch(() => store.state.routeLoading, () => {
        loading.value = store.state.routeLoading
      })
    }
    return { loading }
  },
})
</script>

<style lang="stylus">
.admin-wrapper
  padding-bottom 30px
  position relative

  &__header
    background var(--dark-color)
    color #fff
    padding 60px 20px 80px

  &__body
    margin-top -60px
    padding 0 20px

  &__content
    margin auto
    width 100%
    max-width 1100px

  &__loading
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    display flex
    align-items center
    justify-content center
    background rgba(255, 255, 255, .5)
    backdrop-filter blur(3px)
    font-size 3em
    z-index 100
</style>
